var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleHWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0001C0 14.3389 14.3386 0 31.9999 0C49.6611 0 64 14.3389 64 32.0001C64 49.6614 49.6611 64 31.9999 64C14.3386 64 0 49.6614 0 32.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2434 51.3916H26.8288C27.3045 51.3916 27.6906 51.7777 27.6906 52.2534V54.8391C27.6906 55.3145 27.3045 55.7008 26.8288 55.7008H24.2434C23.7677 55.7008 23.3813 55.3145 23.3813 54.8391V52.2534C23.3813 51.7777 23.7677 51.3916 24.2434 51.3916Z",
    fill: "#FF414D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6906 9.16131C27.6906 8.68564 27.3045 8.29956 26.8288 8.29956H24.2434C23.7677 8.29956 23.3813 8.68564 23.3813 9.16131V46.2206C23.3813 46.6962 23.7677 47.0823 24.2434 47.0823H26.8288C27.3045 47.0823 27.6906 46.6962 27.6906 46.2206",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6905 29.8455C27.6905 27.4885 31.2992 27.6909 31.9997 27.6909C32.7003 27.6909 36.309 27.7641 36.309 29.8455C36.309 31.2331 36.309 39.5643 36.309 54.839C36.309 55.3144 36.6951 55.7008 37.1708 55.7008H39.7563C40.2319 55.7008 40.6182 55.3144 40.6182 54.839C40.6182 37.4615 40.6182 28.0665 40.6182 26.654C40.6182 24.5351 34.0783 23.3816 31.9997 23.3816C27.6905 23.3759 25.5359 24.0941 25.5359 25.5363",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleHWhite);
export default __webpack_public_path__ + "static/media/circle-h-white.940406bde2ed53b8f230b7df4869ddfd.svg";
export { ForwardRef as ReactComponent };